import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-684ad6bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page-subscribe-bar-wrap"
}
const _hoisted_2 = {
  key: 1,
  class: "page-subscribe-bar-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.isShowExperience)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.pageBarTrialTip', { days: _ctx.countdownDay(_ctx.permissionInfo.expire_time) })) + " ", 1),
        _createVNode(_component_el_button, {
          size: "mini",
          round: "",
          type: "primary",
          theme: "orange",
          onClick: _ctx.toSubscribe
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.pageBarTrialAction')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]))
    : (_ctx.isShowExpire)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.pageBarExpireTip', { name: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.name), description: _ctx.$t(_ctx.PermissionFeMap[_ctx.permissionKey]?.description) })) + " ", 1),
          _createVNode(_component_el_button, {
            size: "mini",
            round: "",
            type: "primary",
            theme: "orange",
            onClick: _ctx.toSubscribe
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('serviceSubscribe.pageBarExpireAction')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
}